import { forwardRef } from "react";
import classNames from "classnames";

const CenterContents = forwardRef<HTMLDivElement, JSX.IntrinsicElements["div"]>(({ className, ...props }, ref) => (
  <div className={classNames("scha__center-content-container", className)} ref={ref} {...props} />
));

export default CenterContents;
